export const DEFAULT_TIP_AMOUNT = '0';
export const MAX_TIP_LENGTH = 6; // Dont allow a number longer than $99.99
